export default "__VITE_ASSET__BnSf5dlX__"